import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AdminService } from './api/admin.service';
import { AnalyticsService } from './api/analytics.service';
import { AppService } from './api/app.service';
import { AppleService } from './api/apple.service';
import { CouponService } from './api/coupon.service';
import { CustomerActionsService } from './api/customer-actions.service';
import { GoogleService } from './api/google.service';
import { HealthService } from './api/health.service';
import { IntegrationService } from './api/integration.service';
import { MCPService } from './api/mcp.service';
import { ProgramService } from './api/program.service';
import { SidekickService } from './api/sidekick.service';
import { TranslationsService } from './api/translations.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
